import { connect } from 'react-redux'
import at from 'lodash/at'
import get from 'lodash/get'

import { loadInspectionsForLocation, setInitialInspectionFilters, setInspectionFilters } from '../../actions/inspections'
import { loadInspectorsForLocation } from '../../actions/inspectors'
import { fetchContractsForLocation } from '../../actions/contracts'
import { fetchLocation } from '../../actions/locations'
import { searchAreasByLocation } from '../../actions/areas'

import InspectionsList from '../../components/inspections/inspections'

function mapStateToProps (state, ownProps) {
  const locationId = ownProps.params.locationId
  const pagination = get(state, `pagination.inspectionsByLocation.${locationId}`, {})
  const inspections = at(state.inspections, pagination.ids || [])

  const { startDate, endDate, areaId, inspectorId } = get(state.inspectionFilters, locationId, {})

  return {
    hasNextPage: pagination.nextPageUrl,
    inspections,
    
    startDate,
    endDate,
    areaId,
    inspectorId,
  }
}

function mapDispatchToProps (dispatch, ownProps) {
  const locationId = ownProps.params.locationId

  dispatch(fetchLocation(locationId))
    .then(() => dispatch(fetchContractsForLocation(locationId)))
    .then(() => dispatch(setInitialInspectionFilters(locationId)))
    .then(() => dispatch(searchAreasByLocation({locationId, searchQuery: '', nextPage: false})))
    .then(() => dispatch(loadInspectorsForLocation(locationId, false)))
    .then(() => dispatch(loadInspectionsForLocation(locationId)))

  return {
    onLoadNextPage () {
      dispatch(loadInspectionsForLocation(locationId, true))
    },

    onSetInspectionFilters(name, value) {
      dispatch(setInspectionFilters(locationId, {[name]: value}))
        .then(() => dispatch(loadInspectionsForLocation(locationId)))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(InspectionsList)



// WEBPACK FOOTER //
// ./src/containers/inspections/inspections-container.js